class HsFreeShipping extends HTMLElement {
  static observedAttributes = ['data-total','data-country','data-language','data-currency'];
  connectedCallback() {
    this.select = this.querySelector('select');
    this.message = this.querySelector('.hs-free-shipping__message');
    this.track = this.querySelector('[role="progressbar"]');
    if (!this.select || !this.message || !this.track) return;
    this.render();
  }
  attributeChangedCallback() { if (this.isConnected) queueMicrotask(() => this.render()); }
  render() {
    // Horizon rerenders cart sections after quantity and discount changes.
    // Read the server-rendered cart total rather than parsing formatted prices.
    this.select=this.querySelector('select');this.message=this.querySelector('.hs-free-shipping__message');this.track=this.querySelector('[role="progressbar"]');
    if(!this.select || !this.message || !this.track)return;
    this.select.onchange = () => {
      const selected=this.select.value;
      try { sessionStorage.setItem('hs-shipping-country',selected); } catch {}
      document.querySelectorAll('hs-free-shipping').forEach(el => {el.selectedCountry=selected;el.render();});
    };
    let country=this.selectedCountry || this.dataset.country;
    if(!this.selectedCountry)try {const saved=sessionStorage.getItem('hs-shipping-country');if(saved==='NL'||saved==='BE')country=saved;}catch{}
    if(country!=='BE')country='NL';
    const total=Number(this.dataset.total), threshold=country==='BE'?7500:5000;
    this.hidden=this.dataset.currency!=='EUR'||!Number.isFinite(total);if(this.hidden){this.style.display='none';return;}this.style.removeProperty('display');
    const en=this.dataset.language==='en', name=country==='BE'?(en?'Belgium':'België'):(en?'the Netherlands':'Nederland');
    const remaining=Math.max(0,threshold-total),amount=new Intl.NumberFormat(en?'en-IE':'nl-NL',{style:'currency',currency:'EUR'}).format(remaining/100);
    this.select.value=country;
    this.message.innerHTML=remaining?(en?`Spend another <strong>${amount}</strong> for free shipping to ${name}.`:`Nog <strong>${amount}</strong> tot gratis verzending in ${name}.`):(en?`Your order qualifies for <strong>free shipping</strong> to ${name}.`:`Je bestelling wordt <strong>gratis verzonden</strong> in ${name}.`);
    const percent=Math.max(0,Math.min(100,total/threshold*100));this.track.setAttribute('aria-valuenow',Math.round(percent));this.track.querySelector('span').style.width=percent+'%';
  }
}
if(!customElements.get('hs-free-shipping'))customElements.define('hs-free-shipping',HsFreeShipping);
